import http from '@/uteis/http'
import { criarTramitacao } from '@/uteis/action/tramite'
import { criarTramitacaoProtocoloExterno } from '@/uteis/action/protocolo-externo'
import { criarDevolucao } from '@/uteis/action/devolver'
import { insert, get, remove } from '@/uteis/localStorage'

export default class DestinatarioService {
  async buscarEstruturas (filtro = {}) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/estrutura', { params: filtro }).then((response) => {
        return resolve(response.data.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/estrutura', { params: filtro }).then((response) => {
          return resolve(response.data.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarDepartamento (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/departamento', { params: filtro }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/departamento', { params: filtro }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarDestinatario (numeroProtocolo) {
    try {
      const key = `destinatario-${numeroProtocolo}`
      const destinatario = await get(key)
      if (destinatario) {
        return {
          data: [destinatario]
        }
      }
      return { data: [] }
    } catch (error) {
      return { data: [] }
    }
  }

  async salvarDestinatario (values) {
    console.log('VALUES', values)
    const data = []
    for (const tramite of values.tramites) {
      const destinatario = {
        ...values.destinatario,
        id: tramite.processo,
        idProcesso: tramite.processo,
        idMotivoTramite: tramite.motivo
      }
      const key = `destinatario-${tramite.processo}`
      const expires = 1000 * 60 * 60 * 24 * 3 // 3 dias
      await insert(key, destinatario, expires)
      data.push(destinatario)
    }
    return {
      data: data
    }
  }

  async excluirDestinatario (numeroProtocolo) {
    const key = `destinatario-${numeroProtocolo}`
    await remove(key)
  }

  async tramitar (processosTramitacao, dadosSessao, destinatario, remetente, obs, lote) {
    var tramite = criarTramitacao(processosTramitacao, dadosSessao, destinatario, remetente, obs, lote)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados', { ...tramite }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados', { ...tramite }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async devolver (processo, descricaoMotivo, dadosSessao, destinatario) {
    var devolucao = criarDevolucao(processo, descricaoMotivo, dadosSessao, destinatario)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados', { ...devolucao }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados', { ...devolucao }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async tramitarRecebimentoProtocoloExterno (processo, dadosSessao, dadosEstrutura, lote) {
    var tramite = criarTramitacaoProtocoloExterno(processo, dadosSessao, dadosEstrutura, lote)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados', { ...tramite }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados', { ...tramite }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarDadosDepartamentais (idDepartamento) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/tramitados/destinatarios/dados/departamentos', { params: { idDepartamento } }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/tramitados/destinatarios/dados/departamentos', { params: { idDepartamento } }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
